import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import CustomModal from '../../CustomModal';
import Image from '../../Image';
import userLock from '../../../assets/alert.png';
import useAuth from '../../../hooks/useAuth';
import { closeModal } from '../../../redux/slices/profileSlice';
import useLocales from '../../../hooks/useLocales';

const LogoutDialog = ({ handleClose, handleOpen }) => {
  const { translate } = useLocales();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleLogout = async () => {
    try {
      localStorage.clear();
      dispatch(closeModal());
      navigate('/', { replace: true });
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CustomModal
      maxWidth={'xs'}
      hasClose={false}
      open={handleOpen}
      onClose={handleClose}
      actions={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            width: '100%',
          }}
        >
          <Button
            onClick={handleClose}
            sx={{
              textTransform: 'none',
              borderRadius: '25px',
              px: 4,
              width: '100%',
              border: '1px solid',
              borderColor: theme.palette.primary.main,
              color: 'theme.palette.primary.main !important',
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: theme.palette.primary.lighter,
              },
            }}
          >
            {translate('cancel')}
          </Button>

          <Button
            variant="contained"
            onClick={handleLogout}
            sx={{
              textTransform: 'none',
              borderRadius: '25px',
              width: '100%',
              px: 4,
              boxShadow: 'none',
            }}
          >
            {translate('confirm')}
          </Button>
        </Box>
      }
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          py: 2,
        }}
      >
        <Box>
          <Image src={userLock} style={{ width: 120, height: 120 }} alt="logout" />
        </Box>

        <Typography variant="h6" fontWeight={600}>
          {translate('hint')}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {translate('confirm_logout')}
        </Typography>
      </Box>
    </CustomModal>
  );
};

export default LogoutDialog;
